import {v4} from 'uuid';

const makeId = () => {
  return v4();
};

type WithlId<T> = T & {_id: string};

export {makeId};
export type {WithlId};
